export const TOGGLE_CHANNEL_MODAL = 'TOGGLE_CHANNEL_MODAL';    
export const TOGGLE_MAIN_MENU = 'TOGGLE_MAIN_MENU';    